
import { Component, Prop, Watch, Vue } from "vue-property-decorator";

@Component({
  name: "PageContainer"
})
export default class PageContainer extends Vue {
  @Prop() pageClass: string;
  emitClass: string = "";

  handleEmitClass(className) {
    className ? (this.emitClass = className) : (this.emitClass = "");
  }
  beforeRouteEnter(to, from, next) {
    next();
  }
}
